import { GRADES } from 'src/interfaces/grades.types';

export const LOWER_GRADES = [
  GRADES.IT,
  GRADES.PR,
  GRADES.PK,
  GRADES.TK,
  GRADES.K,
  GRADES.FIRST,
];

export const HIGHER_GRADES = [
  GRADES.UG,
  GRADES.SECOND,
  GRADES.THIRD,
  GRADES.FOURTH,
  GRADES.FIFTH,
  GRADES.SIXTH,
  GRADES.SEVENTH,
  GRADES.EIGHTH,
  GRADES.NINTH,
  GRADES.TENTH,
  GRADES.ELEVENTH,
  GRADES.TWELFTH,
  GRADES.THIRTEENTH,
  GRADES.POST_SECONDARY,
];

export const MIDDLE_SCHOOL_GRADES = [
  GRADES.SIXTH,
  GRADES.SEVENTH,
  GRADES.EIGHTH,
  GRADES.NINTH,
  GRADES.TENTH,
  GRADES.ELEVENTH,
  GRADES.TWELFTH,
  GRADES.THIRTEENTH,
  GRADES.POST_SECONDARY,
];

export const DEFAULT_GRADE = GRADES.THIRD;

export const ANNE_ARUNDEL_ORG_DEFAULT_GRADE = GRADES.FIFTH;

export const VALID_MIDDLE_SCHOOL_CLASS_GRADES = {
  '06': GRADES.SIXTH,
  '07': GRADES.SEVENTH,
  '08': GRADES.EIGHTH,
  '09': GRADES.NINTH,
  '10': GRADES.TENTH,
  '11': GRADES.ELEVENTH,
  '12': GRADES.TWELFTH,
  '13': GRADES.THIRTEENTH,
  PS: GRADES.POST_SECONDARY,
};

export const VALID_CLASS_GRADES = Object.assign(
  {
    IT: GRADES.IT,
    PR: GRADES.PR,
    PK: GRADES.PK,
    TK: GRADES.TK,
    KG: GRADES.K,
    '01': GRADES.FIRST,
    '02': GRADES.SECOND,
    '03': GRADES.THIRD,
    '04': GRADES.FOURTH,
    '05': GRADES.FIFTH,
    UG: GRADES.UG,
  },
  VALID_MIDDLE_SCHOOL_CLASS_GRADES,
);

export const GRADES_7_AND_ABOVE = [
  GRADES.SEVENTH,
  GRADES.EIGHTH,
  GRADES.NINTH,
  GRADES.TENTH,
  GRADES.ELEVENTH,
  GRADES.TWELFTH,
  GRADES.THIRTEENTH,
  GRADES.POST_SECONDARY,
];

export const GRADES_6_AND_ABOVE = [GRADES.SIXTH, ...GRADES_7_AND_ABOVE];
